// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { DeepWriteable } from "@insite/client-framework/Common/Types";
import { Cart } from "@insite/client-framework/Services/CartService";
import { CartLineModel, CartModel, SplitOrderModel } from "@insite/client-framework/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";

const useSplitOrderObjectMapper = (splitOrderJson: string, cart: CartModel) => {
    if (!splitOrderJson) {
        return [];
    }

    const splitOrdersObj = JSON.parse(splitOrderJson);

    if (!splitOrdersObj) {
        return [];
    }

    const splitOrders = splitOrdersObj.map((order: any) => {
        const mappedOrders = {
            ...order,
            status: cart.status || order.Status,
            orderCarrier: order.carrier,
        };

        return mappedOrders;
    }) as SplitOrderModel[];

    const fakeCarts = splitOrders.map(splitOrder => {
        const deepMergedCart = mergeToNew(cart, splitOrder);
        const updatedMergedCart: SplitOrderModel & DeepWriteable<Cart> = {
            ...cloneDeep(deepMergedCart),
            cartLines: splitOrder.lines,
        };

        return updatedMergedCart;
    });

    return fakeCarts as (SplitOrderModel & Cart)[];
};

export default useSplitOrderObjectMapper;
